import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { 'Content-Type': 'application/json' },
});

export const listTransactions = (params = {}) =>
  api.get('/transactions', { params }).then((r) => r.data);

export const createTransaction = (payload) =>
  api.post('/transactions', payload).then((r) => r.data);

export const updateTransaction = (id, payload) =>
  api.put(`/transactions/${id}`, payload).then((r) => r.data);

export const deleteTransaction = (id) =>
  api.delete(`/transactions/${id}`).then((r) => r.data);

export const bulkDeleteTransactions = (ids) =>
  api.post('/transactions/bulk-delete', { ids }).then((r) => r.data);

export const dailyReport = (date) =>
  api.get('/reports/daily', { params: { date } }).then((r) => r.data);

export const monthlyReport = (year, month) =>
  api.get('/reports/monthly', { params: { year, month } }).then((r) => r.data);

export const dashboardStats = () =>
  api.get('/reports/dashboard').then((r) => r.data);
